import type { ReactNode } from 'react';
import './guidance.css';

export interface GuidanceProps {
  message: string;
  hint?: string;
  action?: ReactNode;
}

export function Guidance({ message, hint, action }: GuidanceProps) {
  return (
    <div className="guidance">
      <h2 className="guidance__title">앗!</h2>
      <p className="guidance__message">{message}</p>
      {hint ? <p className="guidance__hint">{hint}</p> : null}
      {action ? <div className="guidance__action">{action}</div> : null}
    </div>
  );
}
